// Copyright (c) 2025 Deere & Company

import DealerRecommendationConfirmModal from '../state/dealer-recommendation-confirm-modal';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const openModal = (state, action) =>
    DealerRecommendationConfirmModal.update(state, {
        actionToTake: {
            $set: action.actionToTake
        },
        isVisible: {
            $set: true
        }
    });

const closeModal = state =>
    DealerRecommendationConfirmModal.update(state, {
        $set: getDefaultState().dealerRecommendationModal
    });

export default (state = getDefaultState().dealerRecommendationModal, action) => {

    const actionTypes = {
        [actions.CLOSE_DEALER_RECOMMENDATION_MODAL]: closeModal,
        [actions.OPEN_DEALER_RECOMMENDATION_MODAL]: openModal
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/reducers/dealer-recommendation-modal.js